import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import techDocsPlugin from '@backstage/plugin-techdocs/alpha';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';



const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage {...props} provider={{
        id: 'github-auth-provider', title: 'GitHub',
        message: 'Sign in using GitHub', apiRef: githubAuthApiRef,
      }} />
    ),
  },
});


export default createApp({
  features: [
    catalogPlugin, 
    navModule, 
    homeModule,
    techDocsPlugin,
    techDocsMermaidAddonModule,
    githubActionsPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
